import React from 'react';
import { ResponsiveContainer, 
    LineChart, 
    Line, XAxis, YAxis, 
    CartesianGrid, 
    Tooltip, Legend } from 'recharts';

const  ChartBlock = ({ data, title = '',total = 0 }) => (
  <div className="spStoreGrid">
    <div className="spStoreInfo">
      {title && <h3 style={{ marginBottom: '1rem' }}>{title}({total})</h3>}
      <div style={{ width: '100%', height: 400 }}>
        <ResponsiveContainer>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="period" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="count" stroke="#8884d8" />
            {/* <Line type="monotone" dataKey="hard" stroke="#82ca9d" /> */}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
    <div className="spStoreImage">
      {/* Placeholder or future image */}
    </div>
  </div>
);

export default ChartBlock;